import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-ondernemingen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-ondernemingen.component.html',
  styleUrl: './tekst-ondernemingen.component.scss',
})
export class TekstOndernemingenComponent {}
